import React, { useEffect, useState, useCallback, useRef } from 'react';
import { ContainerHeader, BtnSearchModal } from '../styles';
import { Box, Stack, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Selection, Table } from 'components';
import { SearchInputHeader } from 'components/search-input-header';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pushDataSearch, changeCloseSearch } from 'store/reducers/app/action';

import ShortcutIcon from '@mui/icons-material/Shortcut';
import ApiServices from 'services';

import { CLIENT_STATUS_ID_BY_SEARCH } from 'commons/constants';

const SEARCH_TYPE_OPTIONS = [
  { value: 0, content: 'Mã' },
  { value: 1, content: 'Tên' },
  { value: 2, content: 'Mã số thuế' },
];

const TYPE_SEARCH = {
  0: 'Code',
  1: 'Name',
  2: 'TaxCode',
};

const SearchToolbar = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [searchType, setSearchType] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [resultList, setResultList] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChangeSearchType = useCallback(
    (e) => {
      setResultList([]);
      setSearchType(e.target.value);
    },
    [searchType],
  );

  const handleChangeKeyword = useCallback(
    (e) => {
      setResultList([]);
      setKeyword(e.target.value);
    },
    [keyword],
  );

  const handleSubmit = async ({ type, key }) => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await ApiServices.searchClientCompany({ [`${TYPE_SEARCH[type]}`]: key });
      if (res?.data?.length > 0) {
        const mapData = res?.data?.map((item, index) => {
          item.index = index + 1;
          if (item?.arrClientCareHistory?.length > 0) {
            item.clientStatusId = item?.arrClientCareHistory[0]?.clientStatusId || '';
            item.clientStatusName = item?.arrClientCareHistory[0]?.clientStatusName || '';
          }
          return item;
        });
        setResultList(mapData || []);
      } else {
        window.UIMessage?.error('Thông báo', 'Không có dữ liệu mà bạn đã chọn');
        setResultList([]);
      }
    } catch (err) {
      window.UIMessage?.error('Thông báo', 'Không có dữ liệu mà bạn đã chọn');
      setResultList([]);

      console.warn('delete Co-loader', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeRoute = async ({ rowData, type, key }) => {
    const clientStatusId = rowData?.clientStatusId;
    if (!clientStatusId) return;

    const dataSearch = {
      clientStatusId: clientStatusId || '',
      clientStatusName: rowData?.clientStatusName || '',
      typeSearch: TYPE_SEARCH[type] || '',
      keySearch: rowData?.name || '',
      isPush: true,
    };

    await dispatch(pushDataSearch(dataSearch));
    await dispatch(changeCloseSearch());
    await history.push(CLIENT_STATUS_ID_BY_SEARCH[clientStatusId].url);
  };

  const columns = [
    {
      id: 'index',
      numeric: true,
      disablePadding: false,
      label: 'STT',
      align: 'center',
      width: '50px',
    },
    {
      id: 'code',
      numeric: true,
      disablePadding: false,
      label: 'Mã KH',
      align: 'center',
      width: '150px',
    },
    {
      id: 'name',
      numeric: true,
      disablePadding: false,
      label: 'Tên KH',
      align: 'center',
      width: '150px',
    },
    {
      id: 'tax_Code',
      numeric: true,
      disablePadding: false,
      label: 'MST',
      align: 'center',
      width: '150px',
    },
    {
      id: 'clientStatusName',
      numeric: true,
      disablePadding: false,
      label: 'Trạng thái',
      align: 'center',
      width: '150px',
    },
    {
      id: '#',
      numeric: true,
      disablePadding: false,
      label: '#',
      align: 'center',
      width: '60px',
      render: (row) => (
        <IconButton
          color="primary"
          size="small"
          onClick={() => handleChangeRoute({ rowData: row, type: searchType, key: keyword })}
        >
          <ShortcutIcon sx={{ fontSize: '30px' }} />
        </IconButton>
      ),
    },
  ];

  return (
    <Box sx={{ paddingBottom: '30px' }}>
      <ContainerHeader>
        <Stack spacing={2} direction="row">
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ width: '200px' }}>
              <Selection
                required
                error={!searchType && searchType !== 0}
                helperText={!searchType && searchType !== 0 && 'Vui lòng chọn Loại tìm kiếm'}
                label="Tìm kiếm theo"
                name="searchType"
                onChange={handleChangeSearchType}
                value={searchType}
                dataArrObject={SEARCH_TYPE_OPTIONS}
                displayNone={false}
              />
            </Box>
            <Box sx={{ width: '400px', marginTop: '10px', marginLeft: '10px' }}>
              <SearchInputHeader
                sx={{ mr: 2 }}
                maxWidth={400}
                value={keyword}
                onChange={handleChangeKeyword}
              />
              {!keyword && (
                <i style={{ fontSize: '12px', color: 'rgb(211, 47, 47)' }}>
                  Vui lòng nhập từ khóa tìm kiếm
                </i>
              )}
            </Box>
            <Box sx={{ marginTop: '12px', marginLeft: '8px' }}>
              <BtnSearchModal
                disabled={(!searchType && searchType !== 0) || !keyword}
                variant="contained"
                startIcon={<SearchIcon />}
                onClick={() => handleSubmit({ type: searchType, key: keyword })}
              >
                Tìm kiếm
              </BtnSearchModal>
            </Box>
          </Box>
        </Stack>
      </ContainerHeader>
      <Table rows={resultList || []} headCells={columns} isHeader={false} />
    </Box>
  );
};

export { SearchToolbar };
